// Native column descriptors for the Task and User sub-grids.
// type drives the renderer in SubGridCell. `anchor` marks the sticky first column.

export const TASK_STATUSES = [
	{ key: "pending", label: "Pending", color: "#e2e4e9" },
	{ key: "ready", label: "Ready", color: "#cfd6e0" },
	{ key: "in_progress", label: "In Progress", color: "#fde3a7" },
	{ key: "done", label: "Done", color: "#a8dca0" },
];

export const USER_STATUSES = [
	{ key: "active", label: "Active", color: "#a8dca0" },
	{ key: "inactive", label: "Inactive", color: "#e2e4e9" },
];

export const NATIVE_COLUMNS_TASK = [
	{ key: "name", label: "Task", type: "text", width: 240, anchor: true },
	{ key: "status", label: "Status", type: "status", width: 140 },
	{ key: "deadline", label: "Deadline", type: "date", width: 150 },
	{ key: "client_id", label: "Client", type: "client", width: 180 },
	{ key: "assignees", label: "Assignees", type: "assignees", width: 230 },
	{ key: "notify", label: "Notify", type: "checkbox", width: 80 },
	{ key: "description", label: "Description", type: "description", width: 200 },
	{ key: "notes", label: "Notes", type: "text", width: 180 },
];

export const NATIVE_COLUMNS_USER = [
	{ key: "first_name", label: "First Name", type: "text", width: 200, anchor: true, readonly: true },
	{ key: "last_name", label: "Last Name", type: "text", width: 200, readonly: true },
	{ key: "engagement_role_id", label: "Engagement Role", type: "member_role", width: 180 },
];

export function nativeColumnsFor(resource) {
	return resource === "task" ? NATIVE_COLUMNS_TASK : NATIVE_COLUMNS_USER;
}
